module.exports = __webpack_public_path__ + "static/media/fhs-rewards-active.0d258168.png";